import { render, staticRenderFns } from "./ResetPasswordInit.vue?vue&type=template&id=3c09d348"
import script from "./ResetPasswordInit.vue?vue&type=script&lang=js"
export * from "./ResetPasswordInit.vue?vue&type=script&lang=js"
import style0 from "./ResetPasswordInit.vue?vue&type=style&index=0&id=3c09d348&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports